import { render, staticRenderFns } from "./Auth.Detail.vue?vue&type=template&id=39fa53f8&"
import script from "./Auth.Detail.vue?vue&type=script&lang=js&"
export * from "./Auth.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports